export const variant = {
  color: {
    gray: 'bg-slate-200 text-slate-600',
    yellow: 'bg-yellow-100 text-yellow-700',
    red: 'bg-red-100 text-red-600',
    green: 'bg-green-100 text-green-600',
    purple: 'bg-purple-100 text-purple-800',
    pink: 'bg-pink-100 text-pink-500',
    primary: 'bg-primary-200 text-primary-600',
    indigo: 'bg-indigo-100 text-indigo-800',
    white: 'bg-white text-slate-700',
  },
  rounded: {
    square: 'rounded-lg',
    round: 'rounded-full',
    half: 'rounded-[100px]',
  },
};

export const iconStyles = {
  sizes: {
    xxs: { bg: 'size-4.5', icon: 'size-3.5' },
    xs: { bg: 'size-6', icon: 'size-4.5' },
    md: { bg: 'size-8', icon: 'size-6' },
    lg: { bg: 'size-12', icon: 'size-8' },
    xl: { bg: 'size-16', icon: 'size-12' },
    xxl: { bg: 'size-24', icon: 'size-16' },
  },
  colors: {
    green: { bg: 'bg-green-100', icon: 'text-green-500' },
    red: { bg: 'bg-red-100', icon: 'text-red-500' },
    purple: { bg: 'bg-purple-100', icon: 'text-purple-500' },
    yellow: { bg: 'bg-yellow-100', icon: 'text-yellow-500' },
    primary: { bg: 'bg-primary-100', icon: 'text-primary-500' },
    slate: { bg: 'bg-slate-200', icon: 'text-slate-500' },
  },
  default: {
    size: 'md',
    color: 'slate',
  },
};
export const getColorByFinancingTypeId = (id) => {
  switch (id) {
    case 1: //autofi
      return variant.color.pink;
    case 2: //cpf
      return variant.color.primary;
    case 3: //cfa
      return variant.color.purple;
    case 4: //tiers fi
      return variant.color.indigo;
  }
};

export const euNationalityOptions = [
  { id: 'allemand', name: 'Allemand' },
  { id: 'autrichien', name: 'Autrichien' },
  { id: 'belge', name: 'Belge' },
  { id: 'bulgare', name: 'Bulgare' },
  { id: 'chypriote', name: 'Chypriote' },
  { id: 'croate', name: 'Croate' },
  { id: 'danois', name: 'Danois' },
  { id: 'espagnol', name: 'Espagnol' },
  { id: 'estonien', name: 'Estonien' },
  { id: 'finlandais', name: 'Finlandais' },
  { id: 'grec', name: 'Grec' },
  { id: 'hongrois', name: 'Hongrois' },
  { id: 'irlandais', name: 'Irlandais' },
  { id: 'italien', name: 'Italien' },
  { id: 'letton', name: 'Letton' },
  { id: 'lituanien', name: 'Lituanien' },
  { id: 'luxembourgeois', name: 'Luxembourgeois' },
  { id: 'maltais', name: 'Maltais' },
  { id: 'neerlandais', name: 'Néerlandais' },
  { id: 'polonais', name: 'Polonais' },
  { id: 'portugais', name: 'Portugais' },
  { id: 'roumain', name: 'Roumain' },
  { id: 'slovaque', name: 'Slovaque' },
  { id: 'slovene', name: 'Slovène' },
  { id: 'suédois', name: 'Suédois' },
  { id: 'tcheque', name: 'Tchèque' },
];
